import * as v from 'valibot';

/**
 * Canonical vendor identifiers used throughout the system.
 * The visual identity of each vendor is encoded in the corresponding
 * theme tokens; pedestal-panels recognises these explicitly to bind
 * panels to their vendor token sets.
 */
export const Vendor = {
  Sony: 'sony',
  GrassValley: 'grassvalley',
  Panasonic: 'panasonic',
  Blackmagic: 'blackmagic',
  Skaarhoj: 'skaarhoj',
  CyanView: 'cyanview',
} as const satisfies Record<string, string>;

export type Vendor = (typeof Vendor)[keyof typeof Vendor];

export const VendorSchema = v.picklist(Object.values(Vendor));
